import React from 'react';
import stylesheet from './DataWellGroup.css';

export default function PositiveArrow() {
  return (
    <div className={stylesheet.typeIcon}>
      <svg
        width="10"
        height="8"
        viewBox="0 0 10 8"
        fill="#00892E"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5 4.37114e-07L10 8L0 8L5 4.37114e-07Z" />
      </svg>
    </div>
  );
}

export function NegativeArrow() {
  return (
    <div className={stylesheet.typeIcon}>
      <svg
        width="10"
        height="8"
        viewBox="0 0 10 8"
        fill="#DB334D"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5 8L0 0L10 1.74846e-06L5 8Z" />
      </svg>
    </div>
  );
}
